/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { LazyModal } from '@freelancer/ui/modal';

export const componentsModals: { [k: string]: LazyModal } = {
  FileViewerModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/file-viewer/file-viewer-modal/file-viewer-modal.component'
      ).then(m => m.FileViewerModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/file-viewer/file-viewer-modal/file-viewer-modal.module'
      ).then(m => m.FileViewerModalModule),
  },
  UserFeedbackModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.component'
      ).then(m => m.UserFeedbackModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.module'
      ).then(m => m.UserFeedbackModalModule),
  },
};
